const Totalcount = [
  {
    "Loan Stage": "New lead",
    "Approved": 40000,
    "Rejected": 43000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Communicated",
    "Approved": 70000,
    "Rejected": 60000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Approved",
    "Approved": 22000,
    "Rejected": 17000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Disbursed",
    "Approved": 66000,
    "Rejected": 6500,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Paid",
    "Approved": 56000,
    "Rejected": 3500,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Rejected",
    "Approved": 57000,
    "Rejected": 55000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Cancelled",
    "Approved": 25000,
    "Rejected": 20000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Expired",
    "Approved": 18000,
    "Rejected": 6000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Payment Overdue",
    "Approved": 65000,
    "Rejected": 60000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Permanent Reject",
    "Approved": 38500,
    "Rejected": 35000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "LUP",
    "Approved": 45000,
    "Rejected": 8000,
    "Total": ()=> this.Approved + this.Rejected
  },
  {
    "Loan Stage": "Ongoing",
    "Approved": 28000,
    "Rejected": 20000,
    "Total": ()=> this.Approved + this.Rejected
  }
]

  export {Totalcount}